import { Box, Button, Grid2 as Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomepageBackgroundImage from "./../assets/Homepage - Background.png";
import Testimonials from "../components/Testimonials";
import FeatureOverview from "../components/FeatureOverview";
import SupportOfferings from "../components/SupportOfferings";
import InfiniteScaling from "../components/InfiniteScaling";



const HeroSection = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            height: 'calc(100vh - 70px)',
            overflow: 'hidden',
            backgroundImage: `
                linear-gradient(
                    to bottom, 
                    #EBEEF3 0%, 
                    #EBEEF300 40%
                ),
                radial-gradient(
                    circle at 100% 70%, 
                    #EBEEF300 0%,
                    #EBEEF303 35%,
                    #EBEEF3 55%,
                    #EBEEF3 100%
                ),
                linear-gradient(
                    to top, 
                    #EBEEF3 0%, 
                    #EBEEF300 40%
                );`,

            '@media (max-width: 1000px)': {
                backgroundImage: `
                    radial-gradient(
                        circle at 100% 80%, 
                        #EBEEF300 0%,
                        #EBEEF303 25%,
                        #EBEEF3 45%,
                        #EBEEF3 100%
                    );`,
            },
        }}>
            {/* Background Images */}
            <Box sx={{
                position: 'absolute',
                top: '0px',
                left: '0',
                width: '100%',
                height: 'calc(100vh - 75px)',
                zIndex: '-1',
                textAlign: 'right',
            }}>
                <img src={ HomepageBackgroundImage } alt="" style={{ 
                    zIndex: '-2',
                    boxShadow: 'inset (-10) 0 3 (-12);',
                    height: '100%', 
                    objectFit: 'fill' 
                }} />
            </Box>

            {/* Main Content */}
            <Box textAlign="left" sx={{
                marginTop: '25vh',
                paddingBottom: '10vh',
                marginLeft: '60px',
                marginRight: '60px',

                '@media (max-width: 750px)': {
                    marginTop: '10vh',
                },

                '@media (min-width: 2000px)': {
                    marginLeft: 'calc(50% - 800px)',
                },
            }}>
                {/* Spend Wisely Live Freely */}
                <Box sx={{ 
                    textAlign: 'left',
                }}>
                    <Typography sx={{ 
                        fontFamily: 'Red Rose', 
                        textTransform: 'none', 
                        fontWeight: '400', 
                        fontSize: '64px', 
                        lineHeight: '80%',
                        color: '#3B0E59',

                        '@media (max-width: 600px)': {
                            fontSize: '48px',
                        },
                        '@media (max-width: 400px)': {
                            fontSize: '36px',
                        }
                    }}>
                        <span style={{ color: '#6841f2' }}>Your Business,</span> But Smarter
                    </Typography>
                </Box>

                {/* Use Subheading */}
                <Box sx={{ textAlign: 'left' }}>
                    <Typography sx={{ 
                        fontFamily: 'Raleway', 
                        textTransform: 'none', 
                        fontSize: '20px', 
                        color: '#212529',

                        maxWidth: '780px',

                        marginTop: '30px',

                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                            marginTop: '20px',
                        },
                    }}>
                        Unify your business operations with our all-in-one platform. 
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'Raleway',
                        textTransform: 'none',
                        fontSize: '20px',
                        color: '#212529',

                        maxWidth: '780px',

                        marginTop: '0px',

                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                            marginTop: '10px',
                        },
                    }}>
                        Manage your finances, projects, and team all in one place.
                    </Typography>
                </Box>
                
                {/* Get Started Button */}
                <Button variant="contained" sx={{
                    backgroundColor: '#6841f2',
                    color: '#fff',
                    fontFamily: 'Red Rose',
                    textTransform: 'none',
                    fontWeight: '600',
                    fontSize: '16px',
                    borderRadius: '5px',
                    padding: '5px 20px',
                    marginTop: '45px',

                    boxShadow: 'none',

                    '@media (max-width: 600px)': {
                        marginTop: '30px',
                    }
                }} onClick={ () => {
                    const scrollAmount = window.innerHeight - 70;
                    window.scrollTo({
                        top: scrollAmount,
                        behavior: 'smooth'
                    });
                } }>Find Out How
                </Button>
            </Box>
        </Box>
    );
};

const JoinOtherCustomersSection = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: '100px',
            marginBottom: '100px',

            textAlign: 'center',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '36px',
                color: '#3B0E59',
                lineHeight: '80%',

                '@media (max-width: 600px)': {
                    fontSize: '24px',
                },
                '@media (max-width: 400px)': {
                    fontSize: '20px',
                }
            }}>
                Join Our Other Satisfied Customers
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '20px',
                color: '#212529',
                marginTop: '20px',

                '@media (max-width: 600px)': {
                    fontSize: '16px',
                    marginTop: '10px',
                },
            }}>
                Trusted by businesses of all sizes, from all industries.
            </Typography>

            <Testimonials />
        </Box>
    );
};

const DecadesOfExperienceSection = () => {
    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '0px',
            marginBottom: '40px',
            backgroundColor: '#220c40',
            paddingTop: '50px',
            paddingBottom: '50px',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '36px',
                color: '#fff',
                lineHeight: '80%',

                '@media (max-width: 1000px)': {
                    fontSize: '28px',
                },
                '@media (max-width: 600px)': {
                    fontSize: '24px',
                },
            }}>
                Decades of Experience
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '20px',
                color: '#f8faf9',
                marginTop: '20px',
                textAlign: 'center',
                paddingLeft: '40px',
                paddingRight: '40px',

                '@media (max-width: 1000px)': {
                    fontSize: '18px',
                },
                '@media (max-width: 600px)': {
                    fontSize: '16px',
                    marginTop: '10px',
                },
            }}>
                Our team has decades of experience in business management and software development. We know what it takes to make your business succeed.
            </Typography>
        </Box>
    )
};

const WhatCanWeDoSection = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: '100px',
            marginBottom: '100px',

            textAlign: 'center',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '36px',
                color: '#3B0E59',
                lineHeight: '80%',

                '@media (max-width: 600px)': {
                    fontSize: '24px',
                },
                '@media (max-width: 400px)': {
                    fontSize: '20px',
                }
            }}>
                What Can We Do For You?
            </Typography>
            <FeatureOverview />
        </Box>
    );
};

const WeAreInvestedInYourSuccessSection = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: '100px',
            marginBottom: '100px',

            textAlign: 'center',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '36px',
                color: '#3B0E59',
                lineHeight: '80%',

                '@media (max-width: 600px)': {
                    fontSize: '24px',
                },
                '@media (max-width: 400px)': {
                    fontSize: '20px',
                }
            }}>
                We're Invested In Your Success
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '20px',
                color: '#212529',
                marginTop: '20px',

                '@media (max-width: 600px)': {
                    fontSize: '16px',
                    marginTop: '10px',
                },
            }}>
                Our team is dedicated to helping you succeed. We are here to support you every step of the way, from implementation to ongoing support.
            </Typography>

            <SupportOfferings />
        </Box>
    );
};

const InfiniteScalingSection = () => {
    return (
        <Box>
            <InfiniteScaling />
        </Box>
    );
};

const GetStartedSection = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: '100%',
            marginTop: '100px',
            marginBottom: '100px',

            height: '30vh',

            textAlign: 'left',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '36px',
                color: '#3B0E59',
                lineHeight: '80%',

                '@media (max-width: 600px)': {
                    fontSize: '24px',
                },
                '@media (max-width: 400px)': {
                    fontSize: '20px',
                }
            }}>
                Get Started Today
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '20px',
                color: '#212529',
                marginTop: '20px',

                '@media (max-width: 600px)': {
                    fontSize: '16px',
                    marginTop: '10px',
                },
            }}>
                Tell us how we can take your business to the next level.
            </Typography>

            <Button variant="contained" sx={{
                backgroundColor: '#6841f2',
                color: '#fff',
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                borderRadius: '5px',
                padding: '5px 20px',
                marginTop: '45px',

                boxShadow: 'none',

                '@media (max-width: 600px)': {
                    marginTop: '30px',
                }
            }} onClick={ () => navigate('/contact-us') }>Talk to Us</Button>
        </Box>
    );
};



export default () => (
	<>
        <HeroSection />
        {/* <JoinOtherCustomersSection /> */}
        <DecadesOfExperienceSection />
        <WhatCanWeDoSection />

        <Box sx={{
            width: '100%',
            maxWidth: '900px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            <Box sx={{
                paddingLeft: '35px',
                paddingRight: '35px',
            }}>
                <WeAreInvestedInYourSuccessSection />
            </Box>
        </Box>

        <InfiniteScalingSection />
        
        <Box sx={{
            width: '100%',
            maxWidth: '900px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            <Box sx={{
                paddingLeft: '35px',
                paddingRight: '35px',
            }}>
                <GetStartedSection />
            </Box>
        </Box>
	</>
);